import { Pipe, PipeTransform } from '@angular/core';
import { PositionPerformerEntity } from '../../entities/position-performer.entity';

@Pipe({ name: 'positionsName' })
export class PositionsNamePipe implements PipeTransform {
    constructor() { }
    transform(positions: PositionPerformerEntity[], defaultVal = ''): string {
        let r = '';
        console.log(positions);
        positions.forEach(u => {
            r += u.performerName + '，';
        });
        if (r) {
            r = r.substring(0, r.length - 1);
        }
        console.log(r);
        return r ? r : defaultVal;
    }
}
